const Textarea = ({
  onChange,
  value,
  id,
  error,
  disabled = false,
  placeholder = "",
  rows = 4,
  maxLength,
}) => {
  return (
    <textarea
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      rows={rows}
      maxLength={maxLength}
      autoComplete="off"
      className={`${error ? 'border-red-200' : 'border-neutral-200'} ${
        disabled ? 'bg-neutral-100 opacity-60' : ''
      } placeholder:text-neutral-500 block w-full px-2 py-2 mt-1 text-sm transition border focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200 resize-none`}
    />
  );
};

export default Textarea;
